/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-show-title.vue?vue&type=template&id=07a871c7&scoped=true&"
import script from "./edit-show-title.vue?vue&type=script&lang=ts&"
export * from "./edit-show-title.vue?vue&type=script&lang=ts&"
import style0 from "./edit-show-title.vue?vue&type=style&index=0&id=07a871c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a871c7",
  null
  
)

export default component.exports